import { http } from "@/lib/api";

const SAVED_KEY = "bc_customer";
const EMPTY_ADDR = { name: "", phone: "", pincode: "", locality: "", address: "", city: "", state: "" };

export const loadSaved = () => {
  try {
    const s = JSON.parse(localStorage.getItem(SAVED_KEY)) || {};
    return { phone: s.phone || "", addr: { ...EMPTY_ADDR, ...(s.addr || {}) } };
  } catch {
    return { phone: "", addr: { ...EMPTY_ADDR } };
  }
};

export const rememberCustomer = (patch) =>
  localStorage.setItem(SAVED_KEY, JSON.stringify({ ...loadSaved(), ...patch }));

const inputCls = "w-full h-10 border border-[#c2c2c2] rounded-sm px-3 text-sm outline-none focus:border-[#C62828]";

export const validateAddress = (addr, pinStatus) => {
  for (const f of ["name", "phone", "pincode", "address", "city", "state"]) {
    if (!addr[f].trim()) return "Please fill all address fields";
  }
  if (addr.phone.replace(/\D/g, "").length < 10) return "Enter a valid phone";
  if (addr.pincode.replace(/\D/g, "").length !== 6) return "Enter a valid 6-digit pincode";
  if (pinStatus && pinStatus.configured && !pinStatus.unknown && pinStatus.serviceable === false)
    return "Delhivery does not deliver to this pincode yet";
  return null;
};

const PinStatus = ({ s }) => (
  <p className="text-xs mt-1" data-testid="pincode-serviceability">
    {s.checking ? (
      <span className="text-[#878787]">Checking delivery…</span>
    ) : s.unknown || !s.configured ? (
      <span className="text-[#878787]">Delivery available via Delhivery</span>
    ) : s.serviceable ? (
      <span className="text-[#388e3c] font-medium">✓ Delhivery delivers to this pincode</span>
    ) : (
      <span className="text-[#d32f2f] font-medium">✗ Sorry, not serviceable at this pincode</span>
    )}
  </p>
);

export const AddressForm = ({ addr, setAddr, pinStatus, setPinStatus, children }) => {
  const checkPincode = async (pin) => {
    const clean = pin.replace(/\D/g, "");
    if (clean.length !== 6) { setPinStatus(null); return; }
    setPinStatus({ checking: true });
    try {
      const { data } = await http.get(`/shipping/serviceability/${clean}`);
      setPinStatus(data);
      if (data.configured && !data.unknown) {
        setAddr((a) => ({ ...a, city: a.city || data.city || "", state: a.state || data.state || "" }));
      }
    } catch {
      setPinStatus({ serviceable: true, unknown: true });
    }
  };

  const field = (name, label, props = {}) => (
    <div>
      <label className="text-xs text-[#878787]">{label}</label>
      <input
        value={addr[name]}
        onChange={(e) => setAddr({ ...addr, [name]: e.target.value })}
        className={inputCls}
        data-testid={`addr-${name}`}
        {...props}
      />
    </div>
  );

  return (
    <div className="p-4 grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="address-form">
      {field("name", "Full Name")}
      {field("phone", "Phone Number", { inputMode: "numeric" })}
      <div>
        <label className="text-xs text-[#878787]">Pincode — city & state auto-fill</label>
        <input
          value={addr.pincode}
          onChange={(e) => { setAddr({ ...addr, pincode: e.target.value }); checkPincode(e.target.value); }}
          inputMode="numeric"
          maxLength={6}
          className={inputCls}
          data-testid="addr-pincode"
        />
        {pinStatus && <PinStatus s={pinStatus} />}
      </div>
      {field("address", "Address (House No, Street, Area)")}
      {field("city", "City/District/Town (auto-filled)")}
      {field("state", "State (auto-filled)")}
      <div className="sm:col-span-2">{children}</div>
    </div>
  );
};
